import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { InstancesPage } from '@/pages/InstancesPage';
import { ApiKeysPage } from '@/pages/ApiKeysPage';
import { AuditLogsPage } from '@/pages/AuditLogsPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { ApiDocsPage } from '@/pages/ApiDocsPage';
import { CatalogManagementPage } from '@/pages/CatalogManagementPage';
import { AppsPage } from '@/pages/AppsPage';
import { NewAppPage } from '@/pages/NewAppPage';
import { AppDetailPage } from '@/pages/AppDetailPage';
import { VolumesPage } from '@/pages/resources/VolumesPage';
import { NetworksPage } from '@/pages/resources/NetworksPage';
import { ContainersPage } from '@/pages/resources/ContainersPage';
import { ContainerDetailPage } from '@/pages/resources/ContainerDetailPage';
import { StacksPage } from '@/pages/resources/StacksPage';
import { ServicesPage } from '@/pages/resources/ServicesPage';
import { EndpointsPage } from '@/pages/resources/EndpointsPage';
import { EndpointDetailPage } from '@/pages/resources/EndpointDetailPage';
import { CatalogStacksPage } from '@/pages/catalog/CatalogStacksPage';
import { StackDetailPage } from '@/pages/catalog/StackDetailPage';
import { ExternalUsersPage } from '@/pages/ExternalUsersPage';
import { ExternalUserDetailPage } from '@/pages/ExternalUserDetailPage';

function AuthWrapper() {
  const apiKey = localStorage.getItem('apiKey');
  if (!apiKey) {
    return <Navigate to="/login" replace />;
  }
  return <Layout />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route path="/" element={<AuthWrapper />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="instances" element={<InstancesPage />} />
          <Route path="resources" element={<Navigate to="/dashboard" replace />} />
          <Route path="resources/volumes" element={<VolumesPage />} />
          <Route path="resources/networks" element={<NetworksPage />} />
          <Route path="resources/containers" element={<ContainersPage />} />
          <Route path="resources/containers/:containerId" element={<ContainerDetailPage />} />
          <Route path="resources/stacks" element={<StacksPage />} />
          <Route path="resources/services" element={<ServicesPage />} />
          <Route path="resources/endpoints" element={<EndpointsPage />} />
          <Route path="resources/endpoints/:endpointId" element={<EndpointDetailPage />} />
          <Route path="api-docs" element={<ApiDocsPage />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="settings" element={<Navigate to="/settings/security-blocks" replace />} />
          <Route path="settings/security-blocks" element={<SettingsPage tab="security-blocks" />} />
          <Route path="settings/domains" element={<SettingsPage tab="domains" />} />
          <Route path="settings/subdomains" element={<SettingsPage tab="subdomains" />} />
          <Route path="settings/tls" element={<Navigate to="/settings/domains" replace />} />
          <Route path="settings/webhooks" element={<SettingsPage tab="webhooks" />} />
          <Route path="apps" element={<AppsPage />} />
          <Route path="apps/new" element={<NewAppPage />} />
          <Route path="apps/:appId" element={<AppDetailPage />} />
          <Route path="external-users" element={<ExternalUsersPage />} />
          <Route path="external-users/:userId" element={<ExternalUserDetailPage />} />
          <Route path="deployments" element={<Navigate to="/apps?tab=deployments" replace />} />
          <Route path="catalog" element={<CatalogManagementPage />} />
          <Route path="catalog/:catalogId" element={<CatalogStacksPage />} />
          <Route path="catalog/:catalogId/stacks/:stackId" element={<StackDetailPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;